import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import { ColorSet } from 'src/redux/reducers/theme';

interface CardProps {
  title: string;
  children?: React.ReactNode;
  colors: ColorSet;
}

export const Card: React.FC<CardProps> = ({ title, children, colors }) => {
  return (
    <View
      style={{
        padding: 11,
        paddingBottom: 16,
        height: 150,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: colors.stroke,
      }}
    >
      <Text
        style={{ fontSize: 13, fontWeight: 600, color: colors.prussianBlue, marginBottom: 13, fontFamily: 'Poppins' }}
      >
        {title}
      </Text>
      <View style={{ flex: 1 }}>{children}</View>
    </View>
  );
};
